import * as ActionTypes from '../ActionTypes';

const componentInitialState = {
    isLoading: false,
    success: false,
    error: false,
    pay_date_data: [],
    registration_number_data: [],
    regNumberLoading: false

}

export const PayDateReducer = function (state = componentInitialState, action) {
    switch (action.type) {
        case ActionTypes.PAY_DATE_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.PAY_DATE_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                pay_date_data: action.payload?.data?.data
            };
        case ActionTypes.PAY_DATE_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        case ActionTypes.PAY_DATE_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.PAY_DATE_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                pay_date_data: action.payload?.data?.data
            };
        case ActionTypes.PAY_DATE_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.REGISTRATION_NUMBER_GET_REQUEST :
            return {
                ...state,
                regNumberLoading: true,
                success: false,
                error: false,
                registration_number_data: []
            };
        case ActionTypes.REGISTRATION_NUMBER_ADD_REQUEST :
            return {
                ...state,
                regNumberLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.REGISTRATION_NUMBER_GET_SUCCESS :
        case ActionTypes.REGISTRATION_NUMBER_ADD_SUCCESS :
            return {
                ...state,
                regNumberLoading: false,
                success: true,
                successMessage: action.payload?.message,
                registration_number_data: action.payload?.data?.data?.[0]
            };
        case ActionTypes.REGISTRATION_NUMBER_GET_ERROR :
        case ActionTypes.REGISTRATION_NUMBER_ADD_ERROR :
            return {
                ...state,
                regNumberLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        default:
            return state;
    }
}